import { type EmailInUseError, formatEmailInUseMessage } from '@/entities/client';

type ContactEmailInUseMessage = {
    message: string;
    // The phrase a form appends as " or <phrase>"; null when the holder is already on this client.
    useExisting: string | null;
};

// The server returns the holder's link on the opened client whenever it has one, so a holder with
// this `clientId` is already on the client being added to and there is nobody left to switch to.
export function formatContactEmailInUseMessage(
    { holder }: EmailInUseError,
    clientId: string,
    clientFirstName: string,
): ContactEmailInUseMessage {
    if (holder.clientId !== clientId) return formatEmailInUseMessage(holder);

    return holder.kind === 'CONTACT'
        ? {
              message: `This email is already associated with one of ${clientFirstName}'s contacts. Change email`,
              useExisting: null,
          }
        : { message: 'This email belongs to this client. Change email', useExisting: null };
}
